import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TemplatesModal } from '../baseComponents/Modal';
import { Button, Text } from '../baseComponents';
import { Radio } from 'antd';
import {
  getTemplateAction,
  getInsightHealthTemplateAction,
} from '../../store/actions/templatesexchange.action';
import { ProfileLogo } from 'src/components';
import './TemplatesExchangeModal.scss';
import { analytics } from 'src/services';

const TemplatesExchangeModal = ({
  isOpen,
  setIsOpen,
  templateOverrideId,
  templateId,
}) => {
  const dispatch = useDispatch();

  const {
    getTemplatesExchangeById,
    getAllTemplatesExchangeList,
    getInsightHealthTemplatesById,
  } = useSelector((state) => state?.templatesState);

  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  const [storeSections, setStoreSections] = useState([]);

  // Get the appropriate data source based on templateOverrideId
  const templateData = templateOverrideId
    ? getTemplatesExchangeById
    : getInsightHealthTemplatesById;

  const user = templateData?.user_count;
  const header = templateData?.templates?.name;
  const format = templateData?.templates?.body?.format;
  const customInstructions = templateData?.templates?.body?.custom_instructions;
  const names = templateData?.practitioner_name;
  const nameWithoutTitle = names?.replace('Dr. ', '');
  const showGetTemplateButton =
    templateData?.templates?.practitioner_id !==
    currentPractitioner?.practitioner_id;

  useEffect(() => {
    if (
      templateData?.templates?.body?.sections &&
      Array.isArray(templateData?.templates?.body?.sections)
    ) {
      let dataArr = [];
      templateData?.templates?.body?.sections.map((key) => {
        dataArr.push({
          sect: key?.name,
          instruct: key?.instructions,
        });
      });
      setStoreSections(dataArr);
    }
  }, [templateData]);

  const handleGetTemplate = () => {
    analytics.track('Clicked Get Note Template', { email: user?.email });
    const appendedTitle = `${header} (${names})`;
    if (templateOverrideId) {
      dispatch(getTemplateAction(templateOverrideId, setIsOpen, appendedTitle));
    } else {
      dispatch(getInsightHealthTemplateAction(templateId, setIsOpen));
    }
  };

  const sections = [
    {
      heading: (
        <div className="ml-2">
          <div className="text-3xl ">{header} </div>
          <div className="flex justify-between flex-wrap gap-5  my-4">
            <div
              className="ant-dropdown-link -mt-1"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="profile-wrapper flex items-center pt-3">
                <ProfileLogo
                  getAllTemplatesExchangeList={
                    templateOverrideId ? getAllTemplatesExchangeList : []
                  }
                  name={
                    templateOverrideId ? nameWithoutTitle : 'Insight Health'
                  }
                  className={'profile-popover-logo mr-1 sm:mr-2 lg:mr-3'}
                  practitioner_name={
                    templateOverrideId ? name : 'Insight Health'
                  }
                />
                <Text
                  type={'span'}
                  className="user-name mr-1 sm:mr-2 lg:mr-3 text-black text-base"
                >
                  {templateOverrideId ? names : 'Insight Health'}
                </Text>
              </div>
            </div>
            {showGetTemplateButton && (
              <div className="">
                <Button
                  type={'button'}
                  onClick={() => {
                    handleGetTemplate();
                  }}
                  className={'text-base'}
                >
                  Get note template
                </Button>
              </div>
            )}
          </div>
        </div>
      ),
      fields: [
        {
          name: 'sections',
          type: 'label',
          title: (
            <div className="mt-2">
              <div className="flex flex-wrap justify-between gap-2">
                <div className="border-0 p-2 px-4 bg-[#f8f8f8] w-full rounded-xl ">
                  <div className="text-lg py-3 font-bold">Sections</div>
                  <div className={`overflow-auto h-64`}>
                    {storeSections?.map((sec, j) => (
                      <div key={j}>
                        <div className="border-0 text-sm mb-2 font-medium ml-2">
                          {sec.sect}
                        </div>
                        <div className="text-xs text-gray-600 rounded-xl bg-white py-2 px-2 mb-2">
                          Custom instruction: {sec.instruct}
                        </div>
                      </div>
                    ))}
                  </div>
                  {format && (
                    <div className="">
                      <div className="text-lg py-2 font-bold">Format</div>
                      <div className="ml-2">
                        <Radio.Group value={format}>
                          <Radio value={format} checked>
                            {format.charAt(0).toUpperCase() + format.slice(1)}
                          </Radio>
                        </Radio.Group>
                      </div>
                    </div>
                  )}
                  {customInstructions && (
                    <div>
                      <div className="text-lg mt-2 py-2 font-bold">
                        Custom instructions
                      </div>
                      <div className="bg-white w-full text-xs rounded-xl mb-3 p-2 h-24 text-gray-600 overflow-auto">
                        {customInstructions}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <TemplatesModal
      open={isOpen}
      sections={sections}
      className={`template-modal`}
      closable={true}
      centered={true}
      submitButtonText=""
      cancelButtonText=""
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {}}
    />
  );
};

export default TemplatesExchangeModal;
